import { Controller } from '@hotwired/stimulus';
import { application } from 'src/app';

application.register('dashboard-select', class extends Controller {
  static values = {
    selected: String
  }

  static targets = ['select']

  connect() {
    this.selectTarget.addEventListener("change", this.dispatchChange.bind(this))
  }

  dispatchChange(event) {
    this.dispatch(
      "dashboardChanged",
      { detail: { dashboardId: event.target.value } }
    )
  }
})
